<template>
	<li
		class="menu_item__parent"
		@mouseover="window.width > 1366 ? (show = true) : (show = false)"
		@mouseleave="window.width > 1366 ? (show = false) : (show = false)"
		@click="window.width < 1366 ? (show = !show) : (show = !show)"
		:class="{
			scrolled: isScrolled,
			white: this.color === 'white',
			black: this.color === 'black',
		}"
	>
		<div class="parent_container" :class="{ active: show == true }">
			<template v-if="menu_item['url']">
				<a
					class="menu_item__parent__primary_link"
					:href="localUrlSwap(menu_item['url'])"
					><span class="title">{{ menu_item['title'] }}</span></a
				>
			</template>
			<template v-else>
				<a class="menu_item__parent__primary_link"
					><span class="title">{{ menu_item['title'] }}</span></a
				>
			</template>
			<span class="plus" v-if="menu_item['children']">&#43;</span>
		</div>

		<transition name="fade">
			<div class="inner_menu_child" v-if="show && menu_item['children']">
				<ul class="menu__child">
					<li
						class="menu_item__child"
						v-for="(sub_menu_item, index) in menu_item['children']"
						:key="index"
					>
						<a
							v-if="sub_menu_item"
							:href="localUrlSwap(sub_menu_item['url'])"
							v-html="sub_menu_item['title']"
						></a>
					</li>
				</ul>
			</div>
		</transition>
	</li>
</template>

<script>
export default {
	data() {
		return {
			param: undefined,
			selected: {},
			removed: {},
			sidePanelVisible: false,
			show: false,
			selectedMenuImage: false,
			topScrollThreshold: 100,
			isScrolled: false,
			color: 'black',
			window: {
				width: 0,
				height: 0,
			},
		};
	},
	props: {
		menu_item: {},
	},
	computed: {},
	watch: {},

	methods: {
		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('edc.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {},

	created() {
		window.addEventListener('scroll', this.didScroll);
		window.addEventListener('resize', this.handleResize);
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.parent_container {
	position: relative;
	grid-column: 1 / span 4;
	display: flex;
	justify-content: space-between;
	align-items: center;

	&.active {
		a.menu_item__parent__primary_link {
			left: 2rem;

			@media (max-width: 1366px) {
				left: 0;
			}
		}

		span {
			&.plus {
				transform: rotate(45deg);
				color: $edc-red;
			}
		}
	}
}

.white {
	.parent_container {
		&.active {
			span {
				&.plus {
					color: $edc-red;
				}
			}
		}
	}

	li {
		&.menu_item__parent {
			span {
				&.title {
					color: black;

					&:hover {
						color: #344b55;
					}
				}

				&.plus {
					color: #344b55;
				}
			}
		}

		div.inner_menu_child {
			ul {
				li {
					a {
						color: black;

						&:hover {
							color: #344b55;
						}
					}
				}
			}
		}
	}
}

li {
	// min-width: 100px;
	position: relative;
	margin-bottom: 1rem;

	@media (max-width: 900px) {
		margin-bottom: 0.75;
	}

	a {
		font-size: 3rem;
		font-weight: bold;
		color: white;
		display: flex;
		height: 100%;
		align-items: center;
		transition: color 0.2s ease;
		align-items: flex-start;
		text-decoration: none;

		@media (max-width: 900px) {
			font-size: 1.5rem;
		}

		&:hover {
			color: #344b55;
		}
	}

	&.menu_item__parent {
		font-size: 32px;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-template-rows: 50px;
		row-gap: 0;
		column-gap: 0;
		height: 100%;
		align-items: center;
		margin-bottom: 1rem;

		@media (max-width: 1366px) {
			grid-template-columns: 1fr;
		}

		@media (max-width: 900px) {
			margin-bottom: 0;
		}

		span {
			&.title {
				font-weight: bold;
			}

			&.plus {
				font-size: 1.5rem;
				transition: 0.2s ease all;
				color: #344b55;
			}
		}

		a.menu_item__parent__primary_link {
			position: relative;
			transition: color 0.2s ease;
			left: 0;
			transition: 0.2s ease all;
			display: inline-flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			&:hover {
				color: #344b55;
			}
		}
	}

	div.inner_menu_child {
		position: absolute;
		grid-column: 5 / span 7;
		z-index: 100;
		top: 10px;
		left: 1rem;

		@media (max-width: 1366px) {
			position: relative;
			grid-column: 1 / span 1;
			top: 0;
			left: 0;
		}

		ul {
			list-style: none;
			margin-bottom: 25px;

			@media (max-width: 1366px) {
				padding-left: 0;
			}

			@media (max-width: 900px) {
				padding-left: 1rem;
				border-left: 2px solid $edc-red;
			}

			li {
				a {
					font-size: 1.5rem;
					// font-weight: normal;
				}
			}
		}
	}
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
}

.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(30px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.bounce-reverse-enter-active {
	animation: bounce-in-rev 0.5s;
}

.bounce-reverse-leave-active {
	animation: bounce-in-rev 0.5s reverse;
}

@keyframes bounce-in-rev {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(-10px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.fade-enter-active {
	animation: fade-in 0.5s;
}

.fade-leave-active {
	animation: fade-in 0.2s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.slide-from-left-enter-active {
	animation: slide-from-left 0.5s;
}

.slide-from-left-leave-active {
	animation: slide-from-left 0.5s reverse;
}

@keyframes slide-from-left {
	0% {
		transform: translateX(100%);
		opacity: 0;
	}
	100% {
		transform: translateX(0%);
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ListItem.vue